// @ts-strict-ignore
import {AfterViewInit, Component, ElementRef, Injector, OnInit, ViewChild} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Permissions, RoomCapability, TrainingRoom} from "@models";
import {Translations} from "@translations";
import {SimInternalStreamingService, NotificationService} from "@services";

export interface DialogData_ScenarioRecordingFileSetConversionDialogInput extends MatDialogDataBaseInput {
	scenarioRecordingId: string;
}

export interface DialogData_ScenarioRecordingFileSetConversionDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-scenario-recording-file-set-conversion-dialog",
	templateUrl: "./scenario-recording-file-set-conversion-dialog.component.html",
	styleUrls: ["./scenario-recording-file-set-conversion-dialog.component.scss"],
	standalone: false,
})
export class ScenarioRecordingFileSetConversionDialogComponent
	extends BasicMaterialDialog<
		ScenarioRecordingFileSetConversionDialogComponent,
		DialogData_ScenarioRecordingFileSetConversionDialogInput,
		DialogData_ScenarioRecordingFileSetConversionDialogOutput
	>
	implements AfterViewInit
{
	T = Translations;
	protected readonly RoomCapability = RoomCapability;
	protected selectedTrainingRoom: TrainingRoom;
	protected nameForSet: string;
	protected selectedMatTabIndex: number;

	protected index_CreationTab: number = 0;
	protected index_ExistingTab: number = 1;
	afterViewInit: boolean = false;

	constructor(
		_injector: Injector,
		private _internalStreamingService: SimInternalStreamingService,
		private _simNotificationService: NotificationService,
	) {
		super(_injector);
	}

	ngAfterViewInit() {
		setTimeout(() => {
			this._internalStreamingService.checkIfRecordingHasFileSet(this.data.scenarioRecordingId).then((result) => {
				if (result) {
					this.selectedMatTabIndex = this.index_ExistingTab;
				} else {
					this.selectedMatTabIndex = this.index_CreationTab;
				}

				this.afterViewInit = true;
			});
		});
	}

	ngOnInit(): void {}

	selectTrainingRoom($event: TrainingRoom) {
		this.selectedTrainingRoom = $event;
	}

	public confirm() {
		this._internalStreamingService
			.createInternalStreamingForRecording({
				displayName: this.nameForSet,
				recordingId: this.data.scenarioRecordingId,
				trainingRoomId: this.selectedTrainingRoom.id,
			})
			.then((result) => {
				if (result) {
					this._simNotificationService.notifySuccess("The files will be adjusted in the background.");
				} else {
					this._simNotificationService.notifyError("Could not create a background job for adjusting the files!");
				}
				//this.close();

				this.selectedMatTabIndex = this.index_ExistingTab;
			});
	}

	protected readonly Permissions = Permissions;
}
